import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const bonuses = [{
  tag: '🎁 Bonus #1',
  emoji: '🎥',
  title: 'CARDBOARD ARCADE PACK',
  text: 'A fun video collection showing step-by-step how to build interactive games like a mini spaceball table, custom roulette wheels, and arcade machines using basic cardboard and a lot of imagination.',
  img: 'https://cdn.magicpatterns.com/uploads/rm6gShtDYvYzPFcSoGNy2X/IMG_1071.webp',
  price: '$25.00',
  tone: 'bg-sky-light',
  tagTone: 'bg-sky/20 text-sky'
}, {
  tag: '🎁 Bonus #2',
  emoji: '✂️',
  title: 'THE 5-MINUTE PAPERCRAFT GUIDE',
  text: "Your go-to handbook for quick, mess-free paper and cardboard crafts. Perfect for afternoons when you don't have special supplies but want an easy activity to pull them away from screens.",
  img: 'https://cdn.magicpatterns.com/uploads/1CpLsWXtwqnmKgUPe3SsG4/IMG_1072.webp',
  price: '$19.00',
  tone: 'bg-sunshine-light',
  tagTone: 'bg-sunshine/30 text-ink'
}, {
  tag: '🎁 Bonus #3',
  emoji: '🌈',
  title: 'LITTLE CREATORS: SLIMES & SENSORY PLAY',
  text: 'A specialized guide packed with easy recipes for homemade slimes, modeling dough, and sensory textures. Ideal for keeping younger siblings happily entertained while making things with their hands.',
  img: 'https://cdn.magicpatterns.com/uploads/dBr1uuNNizqi2RLuGzMBx2/IMG_1073.webp',
  price: '$19.00',
  tone: 'bg-coral-light',
  tagTone: 'bg-coral/20 text-coral'
}];
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-23" data-mp="38hbimw9e3xgc">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-24" data-mp="33h5mp3w37osg">
        <SectionHeading eyebrow="🎁 Exclusive bonuses" title={<>Order today & get these 3 free bonuses</>} subtitle="Get MakerLab today and you will also unlock these 3 exclusive bonuses — yours to keep, at no extra cost." data-id="element-25" data-mp="33gdzohgk2zds" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-26" data-mp="3cjfxta97slhv">
          {bonuses.map((b, i) => <motion.article key={b.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`flex flex-col overflow-hidden rounded-3xl border border-ink/10 ${b.tone}`} data-id="element-27" data-mp="3hhhsytjx0b9p" data-mpi={i}>
              <div className="aspect-square w-full overflow-hidden border-b border-ink/10" data-id="element-28" data-mp="32ra681mvk637">
                <img src={b.img} alt={b.title} className="h-full w-full object-cover" data-id="element-29" data-mp="37lwi05wvc0nt" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-30" data-mp="2f1y23g6emo7r">
                <div className="mb-3 flex items-center justify-between" data-id="element-31" data-mp="27kjc2wtiu9ko">
                  <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${b.tagTone}`} data-id="element-32" data-mp="22kx0ssx973ei">
                    <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-33" data-mp="1xkiq1349pfcs" />
                    {b.tag}
                  </span>
                  <span className="flex items-center gap-1.5 text-sm" data-id="element-34" data-mp="1tmb9o9dpug24">
                    <span className="text-ink/40 line-through" data-id="element-35" data-mp="1olxdbolh8ujx">{b.price}</span>
                    <span className="font-bold text-emerald-600" data-id="element-36" data-mp="1ju5i30rdm0ng">FREE</span>
                  </span>
                </div>
                <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-37" data-mp="1ew42wqx2mlh9">
                  {b.emoji} {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-38" data-mp="15uo1h8o8htp6">
                  {b.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}